import { StarIcon } from '@heroicons/react/20/solid';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Review } from '../../../types/review';

export default function ProductReviews({ reviews }: { reviews: any }) {
  const { t } = useTranslation();

  if (!reviews || reviews.length === 0) {
    return (
      <div className='w-full py-4 text-center text-secondary'>
        <p className='mt-1 text-md font-semibold'>
          {t('productDetails.reviews.noReviews')}
        </p>
      </div>
    );
  }

  return (
    reviews.map((review: Review, reviewIdx: number) => (
      <div key={review.id} className='flex space-x-4 rtl:space-x-reverse text-sm text-secondary'>
        <div className={classNames(
          reviewIdx === 0 ? '' : 'border-t border-gray-200',
          reviewIdx === reviews.length - 1 ? 'pt-10 w-full' : 'py-10 w-full',
        )}
        >
          <div className='flex items-center justify-between'>
            <div>
              <h3 className='font-medium text-secondary'>
                {(review.is_anonymous || review.user.full_name === null) ? t('productDetails.reviews.anonymousUser') : review.user.full_name}
              </h3>
              <p>
                <time dateTime={new Date(review.created_at).toISOString()}>
                  {new Date(review.created_at).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </time>
              </p>
            </div>

            <div className='flex justify-center rtl:space-x-reverse'>
              {[0, 1, 2, 3, 4].map((rating) => (
                <StarIcon
                  key={rating}
                  aria-hidden='true'
                  className={classNames(
                    review.rating > rating ? 'text-primary' : 'text-gray-300',
                    'h-5 w-5 flex-shrink-0',
                  )}
                />
              ))}
            </div>
          </div>

          <p className='sr-only'>
            {review.rating}
            {' '}
            out of 5 stars
          </p>

          <p className='prose prose-sm mt-4 max-w-none text-secondary'>{review.description}</p>
        </div>
      </div>
    ))
  );
}
